import type { CSSProperties, ReactNode } from 'react'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import Row from '@app/components/layout/Row'
import Column from '@app/components/layout/Column'

type PlotRegistryStepTemplateProps = {
  left: ReactNode
  right: ReactNode
  gap?: Property.Gap<(string & {}) | 0>
  leftGap?: Property.Gap<(string & {}) | 0>
  rightGap?: Property.Gap<(string & {}) | 0>
  leftStyle?: CSSProperties
  rightStyle?: CSSProperties
  rowStyle?: CSSProperties
}

const sharedColumnStyle: CSSProperties = {
  flex: '1 1 0',
  minWidth: 0,
  maxWidth: '100%',
}

export const PlotRegistryStepTemplate = ({
  left,
  right,
  gap = '3rem',
  leftGap = '1rem',
  rightGap = '1rem',
  leftStyle,
  rightStyle,
  rowStyle,
}: PlotRegistryStepTemplateProps) => {
  const isMobile = useMediaQuery()

  return (
    <Row
      gap={gap}
      style={{
        alignItems: 'center',
        flexDirection: isMobile ? 'column' : 'row',
        minHeight: '100vh',
        justifyContent: 'center',
        ...rowStyle,
      }}
    >
      <Column
        gap={leftGap}
        style={{ ...sharedColumnStyle, ...leftStyle, ...(isMobile ? { width: '100%' } : {}) }}
      >
        {left}
      </Column>
      <Column
        gap={rightGap}
        style={{ ...sharedColumnStyle, ...rightStyle, ...(isMobile ? { width: '100%' } : {}) }}
      >
        {right}
      </Column>
    </Row>
  )
}
